// import { Control, UseFormRegister, FieldErrors, UseFieldArrayRemove, UseFieldArrayAppend, UseFormSetValue, UseFormWatch } from 'react-hook-form';
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import { Ingredient, Problem, Product, SkinType } from '../../types';
// import { Category, Brand } from '../../types';
// import { filterOptions, renderCategories } from '../../utils/productUtils';
// import { useState } from 'react';
// import { formatPriceWithSpaces } from '../../utils/formatNumber';

// interface Props {
//     register: UseFormRegister<Product>;
//     errors: FieldErrors<Product>;
//     control: Control<Product>;
//     setValue: UseFormSetValue<Product>;
//     fields: any[];
//     append: UseFieldArrayAppend<Product, "properties">;
//     remove: UseFieldArrayRemove;
//     categories: Category[];
//     brands: Brand[];
//     ingredients: Ingredient[];
//     problems: Problem[];
//     skinTypes: SkinType[];
//     // price?: string;
//     // setPrice?: (value: string) => void;
//     // searchBrands?: string;
//     // setSearchBrands?: (value: string) => void;
// }

// const ProductFormFields: React.FC<Props> = ({
//     register,
//     errors,
//     control,
//     setValue,
//     fields,
//     append,
//     remove,
//     categories,
//     brands,
//     ingredients,
//     problems,
//     skinTypes,
//     // price,
//     // setPrice,
//     // searchBrands,
//     // setSearchBrands,
// }) => {
//     // Рендеринг полей формы (название, бренд, категория, свойства и т.д.)
//     // Используйте ваш текущий код для полей формы и разделяйте его логически.

//     const [searchIngredients, setSearchIngredients] = useState('');
//     const [searchProblems, setSearchProblems] = useState('');
//     const [searchSkinTypes, setSearchSkinTypes] = useState('');
//     const [showBrandList, setShowBrandList] = useState(false);
//     const [description, setDescription] = useState("");
//     const [price, setPrice] = useState("");
//     const [searchBrands, setSearchBrands] = useState("");

//     return (
//         <>
//             <div>
//                 <label className="block font-bold mb-1">Название</label>
//                 <input
//                     type="text"
//                     {...register('name', { required: true })}
//                     className="border border-gray-300 p-2 w-full rounded"
//                 />
//                 {errors.name && <span className="text-red-500">{errors.name.message}</span>}
//             </div>

//             {/* Категория */}
//             <div>
//                 <label className="block font-bold mb-1">Категория</label>
//                 <select
//                     {...register('category_id', { required: true })}
//                     className="border border-gray-300 p-2 w-full rounded"
//                 >
//                     <option value="">Выберите категорию</option>
//                     {renderCategories(categories)}
//                 </select>
//             </div>

//             {/* Бренд */}
//             <div className="relative">
//                 <label className="block font-bold mb-1">Бренд</label>
//                 <input
//                     type="text"
//                     placeholder="Начните вводить бренд..."
//                     value={searchBrands}
//                     onChange={(e) => {
//                         setSearchBrands(e.target.value);
//                         setShowBrandList(true);
//                     }}
//                     className="border border-gray-300 p-2 w-full rounded"
//                 />
//                 {showBrandList && searchBrands && (
//                     <ul className="absolute z-10 bg-white border border-gray-300 w-full mt-1 max-h-60 overflow-y-auto rounded shadow-lg">
//                         {filterOptions(brands, searchBrands).map((brand) => (
//                             <li
//                                 key={brand.id}
//                                 className="p-2 hover:bg-gray-100 cursor-pointer"
//                                 onClick={() => {
//                                     setSearchBrands(brand.name); // Устанавливаем имя бренда в поле ввода
//                                     setValue('brand_id', brand.id); // Устанавливаем brand_id в состоянии формы
//                                     setShowBrandList(false); // Закрываем выпадающий список
//                                 }}
//                             >
//                                 {brand.name}
//                             </li>
//                         ))}
//                     </ul>
//                 )}
//                 <input type="hidden" {...register('brand_id', { required: true })} />
//                 {errors.brand_id && <span className="text-red-500">Выберите бренд</span>}
//             </div>

//             {/* Цена */}
//             <div className="flex gap-4">
//                 <div className="flex-1">
//                     <label className="block font-bold mb-1">Цена</label>
//                     {/* <input
//                         type="number"
//                         {...register('price', { required: true, valueAsNumber: true })}
//                         className="border border-gray-300 p-2 w-full rounded"
//                     /> */}
//                     <input
//                         type="text"
//                         value={price}
//                         onChange={(e) => {
//                             const formattedPrice = formatPriceWithSpaces(e.target.value);
//                             setPrice(formattedPrice); // Обновляем локальное состояние
//                             setValue("price", Number(formattedPrice.replace(/\s/g, ""))); // Обновляем значение формы
//                         }}
//                         className="border border-gray-300 p-2 w-full rounded"
//                     />
//                     {errors.price && (
//                         <span className="text-red-500">
//                             {errors.price.type === "required"
//                                 ? "Цена обязательна"
//                                 : "Цена должна быть положительным числом"}
//                         </span>
//                     )}
//                 </div>

//                 {/* Скидка */}
//                 <div className="flex-1">
//                     <label className="block font-bold mb-1">Скидка (%)</label>
//                     <input
//                         type="number"
//                         {...register('discount', { valueAsNumber: true })}
//                         className="border border-gray-300 p-2 w-full rounded"
//                     />
//                 </div>
//             </div>

//             {/* Stock, SKU */}
//             <div className="flex gap-4">
//                 <div className="flex-1">
//                     <label className="block font-bold mb-1">Кол-во на складе</label>
//                     <input
//                         type="number"
//                         {...register('stock', { valueAsNumber: true })}
//                         className="border border-gray-300 p-2 w-full rounded"
//                     />
//                 </div>
//                 <div className="flex-1">
//                     <label className="block font-bold mb-1">Артикул (SKU)</label>
//                     <input
//                         type="text"
//                         {...register('sku')}
//                         className="border border-gray-300 p-2 w-full rounded"
//                     />
//                 </div>
//             </div>

//             {/* Описание */}
//             <div>
//                 <label className="block font-bold mb-1">Описание</label>
//                 <ReactQuill
//                     value={description}
//                     onChange={(value) => {
//                         setDescription(value); // Обновляем локальное состояние
//                         setValue("description", value); // Синхронизируем с формой
//                     }}
//                     modules={{
//                         toolbar: [
//                             [{ header: [1, 2, false] }],
//                             ["bold", "italic", "underline", "strike"],
//                             [{ list: "ordered" }, { list: "bullet" }],
//                             ["link", "blockquote", "code-block"],
//                             ["clean"],
//                         ],
//                     }}
//                     formats={[
//                         "header",
//                         "bold",
//                         "italic",
//                         "underline",
//                         "strike",
//                         "list",
//                         "bullet",
//                         "link",
//                         "blockquote",
//                         "code-block",
//                     ]}
//                     className="border border-gray-300 rounded"
//                 />
//                 {errors.description && <span className="text-red-500">Описание обязательно</span>}
//             </div>

//             <div className="flex gap-4">
//                 {/* Ингредиенты */}
//                 <div className="flex-1">
//                     <label className="block font-bold mb-1">Ингредиенты</label>
//                     <input
//                         type="text"
//                         placeholder="Поиск..."
//                         value={searchIngredients}
//                         onChange={(e) => setSearchIngredients(e.target.value)}
//                         className="border border-gray-300 p-2 w-full rounded mb-2"
//                     />
//                     <div className="max-h-40 overflow-y-auto border border-gray-300 rounded">
//                         {filterOptions(ingredients, searchIngredients).map((ingredient) => (
//                             <label key={ingredient.id} className="flex items-center p-2">
//                                 <input
//                                     type="checkbox"
//                                     value={ingredient.id}
//                                     {...register('ingredients_ids')}
//                                     className="mr-2"
//                                 />
//                                 {ingredient.name}
//                             </label>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Проблемы */}
//                 <div className="flex-1">
//                     <label className="block font-bold mb-1">Проблемы</label>
//                     <input
//                         type="text"
//                         placeholder="Поиск..."
//                         value={searchProblems}
//                         onChange={(e) => setSearchProblems(e.target.value)}
//                         className="border border-gray-300 p-2 w-full rounded mb-2"
//                     />
//                     <div className="max-h-40 overflow-y-auto border border-gray-300 rounded">
//                         {filterOptions(problems, searchProblems).map((problem) => (
//                             <label key={problem.id} className="flex items-center p-2">
//                                 <input
//                                     type="checkbox"
//                                     value={problem.id}
//                                     {...register('problems_ids')}
//                                     className="mr-2"
//                                 />
//                                 {problem.name}
//                             </label>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Типы кожи */}
//                 <div className="flex-1">
//                     <label className="block font-bold mb-1">Типы кожи</label>
//                     <input
//                         type="text"
//                         placeholder="Поиск..."
//                         value={searchSkinTypes}
//                         onChange={(e) => setSearchSkinTypes(e.target.value)}
//                         className="border border-gray-300 p-2 w-full rounded mb-2"
//                     />
//                     <div className="max-h-40 overflow-y-auto border border-gray-300 rounded">
//                         {filterOptions(skinTypes, searchSkinTypes).map((skinType) => (
//                             <label key={skinType.id} className="flex items-center p-2">
//                                 <input
//                                     type="checkbox"
//                                     value={skinType.id}
//                                     {...register('skin_types_ids')}
//                                     className="mr-2"
//                                 />
//                                 {skinType.name}
//                             </label>
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* Динамические свойства (ключ-значение) */}
//             <div>
//                 <label className="block font-bold mb-2">Свойства</label>
//                 {fields.map((field, index) => (
//                     <div key={field.id} className="flex gap-2 mb-2">
//                         <input
//                             type="text"
//                             placeholder="Ключ (например, 'Объем')"
//                             {...register(`properties.${index}.key` as const)}
//                             className="border border-gray-300 p-2 w-1/3 rounded"
//                         />
//                         <input
//                             type="text"
//                             placeholder="Значение (например, '30 мл')"
//                             {...register(`properties.${index}.value` as const)}
//                             className="border border-gray-300 p-2 w-1/3 rounded"
//                         />
//                         <button
//                             type="button"
//                             onClick={() => remove(index)}
//                             className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
//                         >
//                             Удалить
//                         </button>
//                     </div>

//                 ))}
//                 <button
//                     type="button"
//                     onClick={() => append({ key: '', value: '' })}
//                     className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
//                 >
//                     + Добавить свойство
//                 </button>
//             </div>
//         </>
//     );
// };

// export default ProductFormFields;


import { Control, UseFormRegister, FieldErrors, UseFieldArrayRemove, UseFieldArrayAppend, UseFormSetValue } from 'react-hook-form';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Ingredient, Problem, Product, SkinType, Category, Brand } from '../../types';
import { filterOptions } from '../../utils/productUtils';
import { useState } from 'react';
import { formatPriceWithSpaces } from '../../utils/formatNumber';
import { TextField, MenuItem, FormControl, InputLabel, Select, Paper, Typography, Button, Checkbox, FormControlLabel, List, ListItem, ListItemText, ListItemButton, ListSubheader, Dialog, DialogTitle, DialogContent, useTheme, useMediaQuery } from "@mui/material";
import { findCategoryById } from '../../utils/categoryUtils';
import CategoryDialog from './CategoryDialog';

interface FlatCat {
    id: number;
    name: string;
    level: number; // уровень вложенности
}

function flattenCategories(categories: Category[], level = 0): FlatCat[] {
    let result: FlatCat[] = [];
    for (const cat of categories) {
        // добавляем саму категорию
        result.push({ id: cat.id, name: cat.name, level });

        // если есть дочерние — уходим в рекурсию
        if (cat.children && cat.children.length > 0) {
            const childList = flattenCategories(cat.children, level + 1);
            result = result.concat(childList);
        }
    }
    return result;
}


interface Props {
    register: UseFormRegister<Product>;
    errors: FieldErrors<Product>;
    control: Control<Product>;
    setValue: UseFormSetValue<Product>;
    fields: any[];
    append: UseFieldArrayAppend<Product, "properties">;
    remove: UseFieldArrayRemove;
    nameProduct: string;
    setNameProduct: (value: string) => void;
    categories: Category[];
    brands: Brand[];
    ingredients: Ingredient[];
    problems: Problem[];
    skinTypes: SkinType[];
    price: string;
    sku: string;
    setSku: (value: string) => void;
    setPrice: (value: string) => void;
    searchBrands: string;
    setSearchBrands: (value: string) => void;
    description: string;
    setDescription: (value: string) => void;
    categoryId: string;
    setCategoryId: (value: string) => void;
    discount: string;
    setDiscount: (value: string) => void;
}

const ProductFormFields: React.FC<Props> = ({
    register,
    errors,
    setValue,
    fields,
    append,
    remove,
    nameProduct,
    setNameProduct,
    categories,
    brands,
    ingredients,
    problems,
    skinTypes,
    price,
    setPrice,
    sku,
    setSku,
    searchBrands,
    setSearchBrands,
    description,
    setDescription,
    categoryId,
    setCategoryId,
    discount,
    setDiscount,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    // const [description, setDescription] = useState("");
    const [showBrandList, setShowBrandList] = useState(false);
    // Стейт и логика для модального окна выбора категории

    const [dialogOpen, setDialogOpen] = useState(false);

    // Когда пользователь кликает по категории
    const handleCategoryClick = (cat: Category) => {
        // Сохраняем id выбранной категории
        setValue('category_id', cat.id, { shouldValidate: true });
        setCategoryId(cat.id.toString());
    };

    return (
        <>
            <TextField
                label="Название"
                fullWidth
                value={nameProduct}
                onChange={(e) => {
                    setNameProduct(e.target.value);
                    setValue('name', e.target.value, { shouldValidate: true })
                }}
                // {...register('name', { required: "Название обязательно" })}
                error={!!errors.name}
                helperText={errors.name?.message}
                margin="normal"
            />

            <input
                type="hidden"
                {...register('name', { required: "Название обязателен" })}
            />
            {/* Кнопка "Выбрать категорию" и информация о выбранной категории */}
            <FormControl fullWidth margin="normal">
                {errors.category_id?.message && (
                    <Typography
                        variant="body1"
                        sx={{ marginTop: 1, color: 'red' }}
                    >
                        {errors.category_id?.message}
                    </Typography>
                )
                }
                <Button
                    variant="outlined"
                    onClick={() => setDialogOpen(true)}
                >
                    {categoryId ? findCategoryById(categories, Number(categoryId))?.name : "Выбрать категорию"}
                </Button>
                <input
                    type="hidden"
                    {...register('category_id', { required: "Категория обязательно" })}
                />
            </FormControl>

            <CategoryDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                categories={categories}
                onSelectCategory={handleCategoryClick}
            />

            <TextField
                label="Бренд"
                fullWidth
                value={searchBrands}
                onChange={(e) => {
                    setSearchBrands(e.target.value);
                    setShowBrandList(true);
                }}
                error={!!errors.brand_id}
                helperText={errors.brand_id?.message}
                margin="normal"
            />
            {showBrandList && searchBrands && (
                <List sx={{ maxHeight: 250, overflow: 'auto', border: '1px solid #000', borderRadius: 1, background: "#E9EAEC" }}>
                    {filterOptions(brands, searchBrands).map((brand) => (
                        <ListItem key={brand.id} component="div" disablePadding>
                            <ListItemButton onClick={() => {
                                setSearchBrands(brand.name);
                                setValue('brand_id', brand.id, { shouldValidate: true });
                                setShowBrandList(false);
                            }}>
                                <ListItemText primary={brand.name} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            )}

            <input
                type="hidden"
                {...register('brand_id', { required: "Бренд обязателен" })}
            />

            <TextField
                label="Цена"
                fullWidth
                type="text"
                // НЕ вызываем register здесь! 
                // {...register('price', { required: "Цена обязательна" })}
                // (Вместо этого используем локальный state + setValue вручную)

                // Значение, которое видит пользователь (со всеми пробелами)
                value={price}

                // Показываем ошибку, если RHF считает, что поле `price` не заполнено
                error={!!errors.price}
                helperText={errors.price?.message}

                onChange={(e) => {
                    // 1) Убираем все не-цифры, кроме, возможно, точки (если нужны десятичные)
                    //   или просто убираем все пробелы
                    const rawValue = e.target.value.replace(/\s/g, "");

                    // 2) Превращаем в число (если строка пустая, Number("") вернёт 0 — 
                    //   можно сделать дополнительную проверку, если нужно)
                    const numericValue = rawValue ? Number(rawValue) : 0;

                    // 3) Форматируем для красивого отображения
                    const formattedPrice = formatPriceWithSpaces(rawValue);

                    // 4) Кладём отформатированную строку в локальный стейт 
                    setPrice(formattedPrice);

                    // 5) Обновляем значение в RHF (без пробелов — в виде числа)
                    setValue("price", numericValue, { shouldValidate: true });
                }}
                margin="normal"
            />
            <input
                type="hidden"
                {...register('price', { required: "Цена обязательна" })}
            />

            <TextField
                label="Штрихкод"
                fullWidth
                value={sku}                
                onChange={(e) => {
                    setSku(e.target.value);
                    setValue('sku', e.target.value, { shouldValidate: true })
                }}
                // {...register('sku', { required: "Штрихкод обязателен" })}
                error={!!errors.sku}
                helperText={errors.sku?.message}
                margin="normal"
            />
            <input
                type="hidden"
                {...register('sku', { required: "Штрихкод обязателен" })}
            />

            <TextField
                label="Скидка (%)"
                type="number"
                fullWidth
                value={discount}
                onChange={(e) => {
                    setDiscount(e.target.value);
                    setValue("discount", Number(e.target.value)); // Обновляем значение в форме
                }}
                margin="normal"
            />

            <Typography variant="h6" style={{ marginTop: "20px" }} gutterBottom>Описание</Typography>
            <ReactQuill
                value={description}
                onChange={(value) => {
                    setDescription(value);
                    setValue("description", value);
                }}
                theme="snow"
            />

            <Typography variant="h6" style={{ marginTop: "20px" }} gutterBottom>Дополнительные свойства</Typography>
            {fields.map((field, index) => (
                <div key={field.id} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                    <TextField
                        label="Ключ"
                        {...register(`properties.${index}.key` as const)}
                        fullWidth
                        size="small"
                    />
                    <TextField
                        label="Значение"
                        {...register(`properties.${index}.value` as const)}
                        fullWidth
                        size="small"
                    />
                    <Button variant="contained" color="error" onClick={() => remove(index)} size="small">
                        x
                    </Button>
                </div>
            ))}
            <Button variant="contained" color="primary" style={{ marginTop: "10px" }} onClick={() => append({ key: '', value: '' })}>
                + Добавить свойство
            </Button>
        </>
    );
};

export default ProductFormFields;